import { TASK_TYPE, TASK_PRIORITY, TASK_STATUS } from "../../constants/tasks";

export const taskDefaults = {
    title: "",
    description: "",
    scheduledDate: "", 
    scheduledTime: "",
    type: TASK_TYPE.CONTACT,
    priority: TASK_PRIORITY.NORMAL,
    status: TASK_STATUS.NEW,
    selectedMember: "", 
    selectedEmployees: [], // Select model array: [id1, id2, ...]
};
